module.exports = __webpack_public_path__ + "static/media/38.a74b0c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/38.png
// module id = 406
// module chunks = 0